import {Component, Input} from "@angular/core";

@Component({
  selector: 'dot-spinner',
  templateUrl: './dot-spinner.component.html',
  styleUrls: ['./dot-spinner.component.css']
})
export class DotSpinnerComponent {
  @Input('isLoading') isLoading: boolean = true
}
